import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-error',
  imports: [RouterLink],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
})
export class ErrorComponent {
  protected errorCode: string | null = '404';

  constructor(activeRoute: ActivatedRoute) {
    this.errorCode = activeRoute.snapshot.queryParamMap.get('code');
  }
}
